import type { TreeNodeType } from '@/shared/lib/tree'
import type { ChangeEvent } from 'react'
import type { Localization } from '../types'

import React, { useState } from 'react'
import { orderBy } from 'lodash/fp'
import { SearchIcon } from 'lucide-react'

import {
	InputGroup,
	InputGroupAddon,
	InputGroupInput,
} from '@/shared/components/ui/input-group'
import {
	TreeFilter,
	TreeFilterGroup,
	TreeFilterList,
} from '@/shared/components/ui/tree-filter'

type Props = {
	tree: TreeNodeType[]
	value: string[]
	onChange(values: string[]): void
	locale: Localization
}

export default function TreePicker({
	tree,
	value: selected = [],
	onChange: setSelected,
	locale,
}: Props) {
	const [searchText, setSearchText] = useState<string>('')
	const handleInputChange = (event: ChangeEvent<HTMLInputElement>) =>
		setSearchText(event.target.value)
	return (
		<TreeFilter
			className='max-h-[min(calc(var(--radix-popper-available-height)-3rem),400px)]'
			checked={selected}
			setChecked={setSelected}
		>
			<InputGroup className='max-w-full'>
				<InputGroupInput
					value={searchText}
					onChange={handleInputChange}
					placeholder={locale.getSearchPlaceholder?.() || 'Search...'}
				/>
				<InputGroupAddon>
					<SearchIcon className='size-4' />
				</InputGroupAddon>
			</InputGroup>
			<TreeFilterGroup>
				<TreeFilterList
					notFoundText={locale.getNoOptionsMessage() || 'Not found'}
					search={searchText}
					items={orderBy(['children.length'], ['asc'], tree)}
				/>
			</TreeFilterGroup>
		</TreeFilter>
	)
}
